import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((_theme) => ({
  normal: {
    background:
      'linear-gradient(-120deg, #3099ff 3%,#6099ef 20%, #8099ef 100%)',
    color: 'white!important',
    boxShadow: 'none!important',
    '&:hover': {
      background:
        'linear-gradient(-170deg, #3099ff 0%,#6099ef 40%, #8099ef 100%)',
    },
  },
  text: {
    background: 'transparent!important',
    boxShadow: 'none!important',
  },
  soft: {
    background: 'rgba(0, 0, 0, .2)!important',
    color: 'white',
    boxShadow: 'none!important',
  },
}));
